var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './propertySchemaEditor.view.html';
import { escapeJsonPointer, SchemaTypeFactory } from '../../../store/JsonSchemaStore';
import angular from 'angular';
import './propertySchemaEditor.scss';
import { SchemaUtils } from '../../../utils/SchemaUtils';
let PropertySchemaEditorComponent = class PropertySchemaEditorComponent {
    static $inject = ['createSchemaStore', '$scope'];
    // #endregion
    constructor(createSchemaStore, $scope) {
        this.hideRequiredToggle = false;
        this.hasPropertiesV2 = false;
        this.rootEntries = [];
        this.hasEmptyKeys = false;
        this.createSchemaStore = createSchemaStore;
        this.$scope = $scope;
    }
    $onInit() {
        this.initializePropertySchemaEditor();
    }
    $onChanges(changes) {
        if (changes.schema && !changes.schema.isFirstChange()) {
            this.initializePropertySchemaEditor();
        }
    }
    $onDestroy() {
        if (this.off) {
            this.off();
        }
    }
    addPropertyV2(path) {
        this.store.upsertProperty(path, '', SchemaTypeFactory.string(''));
    }
    initializePropertySchemaEditor() {
        try {
            this.store = this.createSchemaStore(this.schema);
        }
        catch (error) {
            console.error('Error parsing schema:', error);
            this.store = this.createSchemaStore({});
        }
        this.off = this.store.subscribe((st) => {
            this.state = st;
            this.$scope.$evalAsync();
            this.recomputeInternalProperties();
            this.notifyChange();
        });
        this.state = this.store.snapshot();
        this.recomputeInternalProperties();
    }
    notifyChange() {
        if (this.onChange) {
            this.onChange({ $schema: this.store.snapshot() });
        }
    }
    // #region Helper Methods
    recomputeInternalProperties() {
        this.recomputeRootEntries();
        this.hasPropertiesV2 = (this.state.type === 'object' &&
            this.state.properties && Object.keys(this.state.properties).length > 0);
    }
    recomputeRootEntries() {
        this.rootEntries = [];
        if (this.state?.type === 'object') {
            const props = this.state.properties || {};
            this.rootEntries = Object.keys(props)
                .sort((a, b) => SchemaUtils.sortNodesByPosition(props[a], props[b]))
                .map(k => ({
                id: (props[k]).__uid + '_' + (props[k]).type,
                key: k,
                node: props[k],
                path: `/properties/${escapeJsonPointer(k)}`,
                objectPath: '/',
            }));
            this.hasEmptyKeys = this.rootEntries.some(entry => entry.key.trim() === '');
        }
    }
};
PropertySchemaEditorComponent = __decorate([
    Component({
        template,
        bindings: {
            schema: '<',
            onChange: '&',
            hideRequiredToggle: '<?',
        },
    }),
    __metadata("design:paramtypes", [Function, typeof (_a = typeof angular !== "undefined" && angular.IScope) === "function" ? _a : Object])
], PropertySchemaEditorComponent);
export { PropertySchemaEditorComponent };
